import * as Phaser from "phaser"
import { GAME_WIDTH } from "../../data/constants"
import type { EnemyData, GameSprite, HealerState } from "../../types"
import { type EnemyState, StatefulEnemyRuntime } from "../enemy-system"

export class HealerEnemy extends StatefulEnemyRuntime<"active"> {
  public constructor(sprite: GameSprite, enemyData: EnemyData) {
    const states: EnemyState<"active">[] = [
      {
        name: "active",
        behaviorState: "flying",
        animationState: "flying",
        update: (context) => {
          const { sprite, enemyData, time, scrollCompensation } = context
          const spec = context.enemyDef?.movementSpec
          if (spec?.action !== "panic-or-sine") return null

          const healerState = enemyData.supportState as HealerState | undefined
          const backlineMinX = GAME_WIDTH * 0.48

          if (!healerState) {
            sprite.y +=
              Math.sin(time / spec.fallbackDivisor) * spec.fallbackAmplitude
            if (sprite.x < backlineMinX) enemyData.vx = scrollCompensation + 1.0
            return null
          }

          if (healerState.phase === "panicking") {
            const jitter = Math.sin(time / 45) * 4
            sprite.y +=
              Math.sin(time / spec.panicDivisorY) * spec.panicAmplitudeY +
              jitter
            sprite.x +=
              Math.sin(time / spec.panicDivisorX) * spec.panicAmplitudeX +
              jitter
            if (sprite.x < backlineMinX) {
              sprite.x = backlineMinX
              enemyData.vx = scrollCompensation + 0.8
            }
            return null
          }

          const homeY = enemyData.homeY ?? sprite.y
          sprite.y =
            homeY + Math.sin(time / spec.calmDivisor) * spec.calmAmplitude

          if (sprite.x < backlineMinX + 40) {
            enemyData.vx = scrollCompensation + 1.2
          } else if (sprite.x > backlineMinX + 140) {
            enemyData.vx = scrollCompensation - 0.4
          } else {
            enemyData.vx = scrollCompensation
          }
          return null
        },
      },
    ]

    super(sprite, enemyData, "active", states)
  }
}
